import { parseNameAddrDisplayName } from './parse-name-addr-display-name'

export type InvitedByRequestLike = {
  getHeader?: (name: string) => string | undefined
}

export const getInvitedByName = (request: InvitedByRequestLike): string | undefined => {
  const header = request.getHeader?.('X-RTU-INVITED-BY')
  return header ? parseNameAddrDisplayName(header) : undefined
}
